import { User } from "@/types/ApiTypes";
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
type userWithPagination = User & {
    pagination: {
        totalPages: number;
        totalItems: number;
        page: number
    },
    clients: User[],


}



interface ClientsSearchDataState {
    clientsSearchData: userWithPagination | null; // Replace `any` with the actual type of your data if known
}

const initialState: ClientsSearchDataState = {
    clientsSearchData: null,
};

const clientsSearchDataSlice = createSlice({
    name: 'clientsSearchData',
    initialState,
    reducers: {
        setClientsSearchData: (state, action: PayloadAction<userWithPagination>) => {
            // Replace `any` in PayloadAction if you know the data type
            state.clientsSearchData = action.payload;
        },
        clearClientsSearchData: (state) => {
            state.clientsSearchData = null;
        },
    },
});

// Export actions to use in your components
export const { setClientsSearchData, clearClientsSearchData } = clientsSearchDataSlice.actions;

// Export the reducer to add to your store
export default clientsSearchDataSlice.reducer;
